import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import App from "./modules/App";
import { store } from "./store";

import "./index.css";
import "./mui-overrides.css";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
